import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class roleListItemCtrl implements IController {

  role: any;
  isSelected: boolean;
  excludeIds: any;
  onToggle: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.excludeIds) {
      this.excludeIds = [];
    }
  }

  //////////////////////////////////////////////////////

  getDisabledValue() {
    if (!this.role) {
      return true;
    }
    return _.findIndex(this.excludeIds, (id) => {
      return this.role.id === id;
    }) !== -1;
  }

  onBeforeToggle($event) {
    this.onToggle({role: this.role});
  }

}

angular
  .module('bringoz.admin.policies')
  .component('roleListItem', {
    bindings: {
      role: '<',
      isSelected: '<',
      excludeIds: '<?',
      onToggle: '&'
    },
    template: require('./role-list-item.html').default,
    controller: roleListItemCtrl
  });
